import { PageHeader } from "@portal/components/layout/PageHeader";
import { SegmentedControls, Text } from "@portal/components/primitives";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useState } from "react";
import { type EntityScope, type ScopeOption } from "../../shared/scope";
import { AgentUserMenu } from "../settings/AgentUserMenu";
import { AgentHeaderActionButtons } from "../shared/AgentHeaderActionButtons";
import { AgentDashboardMetricsView } from "./metrics/AgentDashboardMetricsView";
import { DashboardSearchPanel } from "./search/DashboardSearchPanel";

const AGENT_SCOPE_OPTIONS: [ScopeOption, ...ScopeOption[]] = [
	{ id: "me", label: "Me" },
	{ id: "everyone", label: "Agency" },
];

export const DashboardView = () => {
	const { user } = useAuthenticatedUser();
	const [scope, setScope] = useState<EntityScope>("me");

	return (
		<div data-testid="agent-dashboard" className="flex h-full w-full flex-col min-w-[500px]">
			<PageHeader
				userMenu={<AgentUserMenu />}
				actionButtons={<AgentHeaderActionButtons />}
				title={
					<>
						{user.type === "agent" ? (
							<div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
								<Text
									data-testid="dashboard-title"
									type="heading"
									color="primary"
									className="whitespace-nowrap"
								>
									{`${user.firstName} ${user.lastName}`}
								</Text>
								<div className="h-[22px] shrink-0 border-l border-bc-strong" aria-hidden />
								<Text
									data-testid="dashboard-agency-name"
									type="heading"
									color="tertiary"
									className="min-w-0 break-words font-normal"
								>
									{user.agencyName}
								</Text>
							</div>
						) : (
							<Text data-testid="dashboard-title" type="heading" color="primary">
								Dashboard
							</Text>
						)}
						<SegmentedControls<EntityScope>
							data-testid="dashboard-scope-toggle"
							value={scope}
							onChange={setScope}
							className="shrink-0"
						>
							{AGENT_SCOPE_OPTIONS.map((option) => (
								<SegmentedControls.Segment key={option.id} value={option.id}>
									{option.label}
								</SegmentedControls.Segment>
							))}
						</SegmentedControls>
					</>
				}
			/>
			<div className="flex flex-1 flex-col overflow-y-auto px-8 pt-[40px] pb-[100px]">
				<div className="flex w-full flex-col gap-[72px]">
					<AgentDashboardMetricsView scope={scope} />
					<div className="mx-auto w-full max-w-[1050px]">
						<DashboardSearchPanel />
					</div>
				</div>
			</div>
		</div>
	);
};
